import { render, staticRenderFns } from "./CustomerShippingEditor.vue?vue&type=template&id=6c41130b&scoped=true"
import script from "./CustomerShippingEditor.vue?vue&type=script&lang=js"
export * from "./CustomerShippingEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomerShippingEditor.vue?vue&type=style&index=0&id=6c41130b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c41130b",
  null
  
)

export default component.exports